import { Component, type ReactNode } from 'react'
export class ImmersiveBoundary extends Component<
  { children: ReactNode; onReturn: () => void },
  { failed: boolean }
> {
  state = { failed: false }
  static getDerivedStateFromError() {
    return { failed: true }
  }
  render() {
    return this.state.failed ? (
      <div
        className="flex h-full flex-col items-center justify-center gap-3 bg-muted p-8 text-center"
        role="alert"
      >
        <p className="font-serif text-xl">The immersive gallery could not open.</p>
        <p className="max-w-sm text-sm text-muted-foreground">
          Your browser may not support this 3D view. The 2D map has the same knowledge and
          exploration tools.
        </p>
        <button
          onClick={this.props.onReturn}
          className="rounded-md border bg-card px-4 py-2 text-sm"
        >
          Return to 2D map
        </button>
      </div>
    ) : (
      this.props.children
    )
  }
}
